<section class="ads-creation-dialog">
  <button
    type="button"
    class="ads-creation-dialog__close-btn"
    (click)="close()"
  >
    <img src="assets/icons/xmark-secondary.svg" alt="check icon" />
  </button>
  <div class="ads-creation-dialog__header">
    <h1 class="ads-creation-dialog__header-title">La pub pour canalbox</h1>
    <p class="ads-creation-dialog__header-subtitle">Créée le : 10/08/2023</p>
  </div>
  <div class="ads-creation-dialog__content">
    <section class="ads-creation-dialog__content-header">
      <div class="ads-creation-dialog__content-header-left">
        <p>Annonceur: <span></span> canal+</p>
        <p>Tarifs: 120 000 FCFA</p>
      </div>

      <div class="ads-creation-dialog__content-header-right">
        <p>Marque: <span></span> canal+</p>
        <p>Support: Affiche</p>
      </div>
    </section>

    <section class="ads-creation-dialog__content-body">
      <table class="ads-creation-dialog__content-table">
        <tr>
          <th>Type de média</th>
          <td>Télévision</td>
        </tr>
        <tr>
          <th>Pays</th>
          <td>Côte d'Ivoire</td>
        </tr>
        <tr>
          <th>Groupe</th>
          <td>Télécommunication</td>
        </tr>
        <tr>
          <th>Secteur</th>
          <td>Internet</td>
        </tr>
        <tr>
          <th>Sous secteur</th>
          <td>Internet</td>
        </tr>
        <tr>
          <th>Format</th>
          <td>23</td>
        </tr>
        <tr>
          <th>Date</th>
          <td>12/02/2024</td>
        </tr>
        <tr>
          <th>Campagne</th>
          <td>Canal Box</td>
        </tr>
        <tr>
          <th>Type de campagne</th>
          <td>Produit</td>
        </tr>
        <tr>
          <th>Emplacement</th>
          <td>12:33:22</td>
        </tr>
      </table>
    </section>

    <section class="ads-creation-dialog__content-video-wrapper">
      <p>Vidéo</p>
      <div class="ads-creation-dialog__content-video"></div>
    </section>
  </div>
</section>
